import { GROUPED_PRIVILEGES } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { RecentIncidentsPage } from '@/pages/reporting/recent-incidents';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/reporting/recent-incidents')({
  beforeLoad: () => {
    privilegeGuardRoute({ privileges: GROUPED_PRIVILEGES.viewReporting });
  },
  component: RecentIncidentsPage,
});
